import React from 'react';
import { Globe } from 'lucide-react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

interface LanguageToggleProps {
  language: string;
  setLanguage: (lang: string) => void;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ language, setLanguage }) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button 
          className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-3 py-2 rounded-full text-sm 
                     shadow-sm hover:bg-white transition-all duration-300 outline-none"
          aria-label="Select language"
        >
          <Globe size={16} />
          {language === 'en' ? 'English' : 'Dansk'}
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="min-w-[120px] bg-white rounded-lg shadow-lg p-1 animate-in fade-in-0 zoom-in-95"
          sideOffset={5}
          align="end"
        >
          <DropdownMenu.Item
            className={`flex items-center px-3 py-2 text-sm rounded-md cursor-pointer transition-colors
                       ${language === 'en' 
                         ? 'bg-[#A68B7C]/10 text-[#A68B7C]' 
                         : 'hover:bg-[#A68B7C]/5 text-gray-600 hover:text-[#A68B7C]'}`}
            onClick={() => setLanguage('en')}
          >
            English
          </DropdownMenu.Item>
          
          <DropdownMenu.Item
            className={`flex items-center px-3 py-2 text-sm rounded-md cursor-pointer transition-colors
                       ${language === 'da' 
                         ? 'bg-[#A68B7C]/10 text-[#A68B7C]' 
                         : 'hover:bg-[#A68B7C]/5 text-gray-600 hover:text-[#A68B7C]'}`}
            onClick={() => setLanguage('da')}
          >
            Dansk
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default LanguageToggle;